import { HttpClient, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const InvoiceProjectService = {
  findInvoiceProjects: ({
    user_name,
    password,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'authenticate',
    output: JSON_STRING,
    user_name,
    password,
  }),
  findInvoiceProjects2: () => HttpClient.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'load_invoice_project',
    output: JSON_STRING,
  }),
  findInvoiceProjectDetails: ({
    invoice_project_id
  }) => HttpClient.get(SETTINGS_URL, {
    section: 'company_setup',
    action: 'invoice_project_details',
    output: JSON_STRING,
    invoice_project_id
  }),
  findInvoiceProjectSetup: () => HttpClient.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'invoice_project_form',
    output: JSON_STRING,
  }),
  insertInvoiceProject: ({
    invoice_project_name,
    default_currency_id,
    royalty_flag,
    copy_invoice_project_id,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'save_invoice_project',
    invoice_project_name,
    default_currency_id,
    royalty_flag,
    copy_invoice_project_id,
  }),
  deleteInvoiceProject: ({
    invoice_project_id
  }) => MHTTPCL.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'remove_invoice_project',
    invoice_project_id,
  }),

  updateTextElement: ({
    invoice_project_id,
    text_elements
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'company_setup',
    action: 'update_text_elements',
    invoice_project_id,
    text_elements: JSON.stringify(text_elements)
  }),
  updateInvitationEmail: ({
    invoice_project_id,
    share_invitation_email_data
  }) => HttpClient.post('/modify.pl', {
    modify_type: 'json',
    table: 'invoice_projects',
    column: 'text_elements',
    json_op: "set",
    json_key: 'share_invitation_email_data',
    name: 'text_elements',
    kVal: invoice_project_id,
    value: JSON.stringify(share_invitation_email_data)
  }),

}